import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const fetchProfileRoutine = createRoutine('Profile/FETCH')
export const createFetchProfilePromise = promisifyRoutine(fetchProfileRoutine)

export const updateProfileRoutine = createRoutine('Profile/UPDATE')
export const createUpdateProfilePromise = promisifyRoutine(updateProfileRoutine)

export const updatePasswordRoutine = createRoutine('Profile/UPDATE_PASSWORD')
export const createUpdatePasswordPromise = promisifyRoutine(updatePasswordRoutine)

export const deleteUserRoutine = createRoutine('Profile/DELETE')
export const createDeleteUserPromise = promisifyRoutine(deleteUserRoutine)
